
import * as YUP from 'yup'

import { msgs } from '../../services/Validation/msgs'

export const ExpensesValidation = YUP.array().of(
    YUP.object().shape(
    {
    expense_type_id :YUP.number().min(0,msgs.min_msg(0)).required(msgs.required_msg),
    expense_value:YUP.number().required(msgs.required_msg),
    vat:YUP.number(),
    tax_num:YUP.string().nullable().when('vat',([vat],schema)=>{
      if (vat && vat>0) return schema.nonNullable().required(msgs.required_msg)
        return schema
    }),
    expense_date:YUP.string().required(msgs.required_msg),
    invoice_date:YUP.string().required(msgs.required_msg),
    invoice_num:YUP.string().required(msgs.required_msg),
    expense_mode_id:YUP.number().min(0,msgs.min_msg(0)).required(msgs.required_msg),
    notes:YUP.string().nullable(),
    invoice_copy:YUP.string()
         .when('new_line',([new_line],schema)=>{
        if (new_line) return schema.required(msgs.required_msg)
        return schema

    }),
    invoice_copy_file: YUP.mixed().test(
  'fileValidation',
  msgs.file_invalid,
  function (value) {
    if (!value || typeof value === 'string') return true;

    const file = value as File;

    if (file.size > 5 * 1024 * 1024) {
      return this.createError({ message: msgs.file_larg });
    }

    if (!["image/jpeg", "image/png", "application/pdf"].includes(file.type)) {
      return this.createError({ message: msgs.file_type });
    }

    return true;
  }
)


})
).min(1,msgs.min_msg(1))


export const dateSchema = YUP.object().shape({
  date_from: YUP.date(),

  date_to: YUP.date()
    .min(
      YUP.ref('date_from'),
      msgs.date_from_to
    ),
});



export const ExpensesValidationByRow = 
    YUP.object().shape(
    {
    expense_type_id :YUP.number().min(0,msgs.required_msg).required(msgs.required_msg),

    expense_value:YUP.number().required(msgs.required_msg).min(0,msgs.min_msg(0))
        .transform((value, originalValue) =>
            originalValue === '' ? null : value
          ).typeError('هذا الحقل يجب أن يكون رقم'),

    vat:YUP.number().nullable().transform((value, originalValue) =>
              originalValue === '' ? null : value
            ).typeError('هذا الحقل يجب أن يكون رقم'),

    tax_num:YUP.string().nullable().when('vat',([vat],schema)=>{
     
      if (vat && vat>0) return schema.nonNullable().required(msgs.required_msg)
        return schema
    }),

    expense_date:YUP.string().required(msgs.required_msg),

    invoice_date:YUP.string().required(msgs.required_msg),

    invoice_num:YUP.string().required(msgs.required_msg),

    expense_mode_id:YUP.number().min(0,msgs.required_msg).required(msgs.required_msg),
    notes:YUP.string().nullable(),

    invoice_copy:YUP.string()
         .when('new_line',([new_line],schema)=>{
        if (new_line) return schema.required(msgs.required_msg)
        return schema

    }),
invoice_copy_file: YUP.mixed()
  .nullable()

  .test("fileSize", msgs.file_larg, function (value) {

    if (!value) return true;
    if (typeof value === "string") return true;

    return (value as File).size <= 5 * 1024 * 1024;
  })

  .test("fileType", msgs.file_type, function (value) {
    //console.log("YUP TEST RUNNING:", value);

    if (!value) return true;
    if (typeof value === "string") return true;

    const allowed = [
      "image/jpeg",
      "image/png",
      "application/pdf",
    ];

    return allowed.includes((value as File).type);
  })
})





export const FileFieldValidationByRow = 
    YUP.object().shape(
    {
    
  invoice_copy_file: YUP.mixed()
    .nullable()

    .test("fileSize", msgs.file_larg, function (value) {
    
      if (!value) return true;
      if (typeof value === "string") return true;

      return (value as File).size <= 5 * 1024 * 1024;
    })

    .test("fileType", msgs.file_type, function (value) {
      //console.log("YUP TEST RUNNING:", value);

      if (!value) return true;
      if (typeof value === "string") return true;

      const allowed = [
        "image/jpeg",
        "image/png",
        "application/pdf",
      ];

      return allowed.includes((value as File).type);
    })
})



